module.exports = __webpack_public_path__ + "static/media/twitter_icon.c11b01a3.svg";